import React from "react";
import {FormattedHTMLMessage} from "react-intl";
import {connect} from "react-redux";

const Copyright = (props) => {

  const {fabricatorData} = props;
  const date = new Date();

  return (
    <div className={"copyright" + (fabricatorData.isAmericanImport ? " copyright--transparent" : "")}>
      <FormattedHTMLMessage id="copyright" values={{year: date.getFullYear()}}/>
    </div>
  );
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState
  };
};

export default connect(mapStateToProps)(Copyright)
